import React, { memo } from 'react';
import { Row, Modal, Button } from 'react-bootstrap';
import TypeSummaryAccordian from './TypeSummaryAccordian';
import PropTypes from 'prop-types';
import StillageDataTable from '../stillage-table/StillageDataTable';

const WidgetModal = ({ title, showModal, setShowModal, modalData, loading }) => {
    return (
        <Modal show={showModal} onHide={() => setShowModal(false)} centered size="xl" scrollable>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <TypeSummaryAccordian data={modalData} />
                <Row>
                    <StillageDataTable data={modalData} loading={loading} hover={false} />
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
            </Modal.Footer>
        </Modal>
    )
}

WidgetModal.propTypes = {
    title: PropTypes.string,
    showModal: PropTypes.bool,
    setShowModal: PropTypes.func,
    modalData: PropTypes.array,
    loading: PropTypes.bool
};

export default memo(WidgetModal);